import 'babel-polyfill'
import 'typeface-muli'
import React from 'react'
import ReactDOM from 'react-dom'
import history from './history'
// import './react-table-defaults'
import './styles/index.css'
import JssProvider from 'react-jss/lib/JssProvider'
import { create } from 'jss'
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles'
import { unregister } from './registerServiceWorker'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { routes } from './fuse-configs/fuseRoutesConfig'
import { FuseLayout, FuseTheme, FuseAuthorization } from '@fuse'
import MainToolbar from './main/MainToolbar'
import MainNavbarContent from './main/MainNavbarContent'
import MainNavbarHeader from './main/MainNavbarHeader'
import MainFooter from './main/MainFooter'
import jssExtend from 'jss-extend'
// import QuickPanel from 'main/quickPanel/QuickPanel'
import store from 'store'
// import SettingsPanel from 'main/SettingsPanel'
import { Auth } from 'auth'

import axios from 'axios'

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend()]
})

jss.options.insertionPoint = document.getElementById('jss-insertion-point')
const generateClassName = createGenerateClassName()

// AWS API Key interceptor
axios.defaults.timeout = 60000

const axiosLogsInstance = axios.create()
axios.interceptors.request.use(async config => {
  if (process.env.NODE_ENV === 'production') {
    axiosLogsInstance.post(`${process.env.REACT_APP_API_LOG}/crm/logs/add`, {
      idBackendEntita: store.getState().auth.user.data.id,
      route: config.url,
      payload: config.data,
      method: config.method
    }).then(response => {
      console.log('[interceptor] log inserito correttamente')
    }).catch(error => console.log('[interceptor/logs] error:', error))
  }

  const token = window.localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (!error.response) {
    return
  }

  const { response: { status } } = error
  if (status === 401) {
    window.localStorage.removeItem('user')
    history.push({
      pathname: '/login'
    })
  }
  return Promise.reject(error)
})

ReactDOM.render(
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <Provider store={store}>
      <Auth>
        <Router history={history}>
          <FuseAuthorization routes={routes}>
            <FuseTheme>
              <FuseLayout
                routes={routes}
                toolbar={
                  <MainToolbar />
                }
                /* navbarHeader={
                  <MainNavbarHeader />
                } */
                navbarContent={
                  <MainNavbarContent />
                }
                /* footer={
                  <MainFooter />
                } */
                /* rightSidePanel={
                  <React.Fragment>
                    <QuickPanel />
                  </React.Fragment>
                } */
                /* contentWrapper={
                                    <SettingsPanel/>
                                } */
              />
            </FuseTheme>
          </FuseAuthorization>
        </Router>
      </Auth>
    </Provider>
  </JssProvider>
  , document.getElementById('root'))

unregister()
